import { useCallback, useMemo } from 'react'
import { useGetCarrierBids } from '../types/apiTypes'

export const useBidsApi = () => {
  const { data, loading: isLoading, refetch } = useGetCarrierBids({})
  const { bids: bidsArray } = data || {}
  const bids = useMemo(() => bidsArray || [], [bidsArray])

  /**
   * Get carrier bids list
   */
  const getCarrierBids = useCallback(async () => {
    try {
      await refetch()
    } catch (e) {
      // no-op
    }
  }, [refetch])

  const pendingBids = useMemo(
    () => bids.filter(bid => ['pending', 'countered'].includes(bid.status)),
    [bids]
  )
  const acceptedBids = useMemo(() => bids.filter(bid => bid.status === 'accepted'), [bids])
  const declinedBids = useMemo(() => bids.filter(bid => bid.status === 'declined'), [bids])

  const pendingBidsCount = useMemo(() => pendingBids.length || 0, [pendingBids])
  const acceptedBidsCount = useMemo(() => acceptedBids.length || 0, [acceptedBids])
  const declinedBidsCount = useMemo(() => declinedBids.length || 0, [declinedBids])

  return {
    getCarrierBids,
    isLoading,
    pendingBids,
    acceptedBids,
    declinedBids,
    pendingBidsCount,
    acceptedBidsCount,
    declinedBidsCount,
  }
}
